import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { NewTransactionalPassword } from "../../../../components/templates";
import { strings } from "../../../../localization";
import { useGlobalStore } from "../../../../contexts/globalStoreContext";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { useNavigateCustom } from "../../../../hooks";

const { description, title } = strings.pages.PasswordReset;
const { confirmChange } = strings.components.buttons;

const PasswordReset: React.FC = observer(() => {
	const { passwordStore } = useGlobalStore();
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	const navigate = useNavigateCustom();
	const [password, setPassword] = useState("");

	React.useEffect(() => {
		updatePageView({ name: "Vivo Money FGTS Confirmar Contratação Criar Nova Senha", pagePath: "/fgts/confirmar-contratacao/esqueci-a-senha" });
	}, []);

	const onConfirmChange = async (): Promise<void> => {
		const { success } = await passwordStore.sendNewTransactionPassword(password);
		addAnalyticEvent({ action: "click.button", step: "fgts:confirmar-contratacao:esqueci-a-senha", description: confirmChange }, { applySanitize: true});

		if (success) {
			navigate("/sign-contract/forgot-password/success-alter-password");
		}
	};

	return (
		<NewTransactionalPassword
			heroDataInfo={{
				title,
				description,
			}}
			textButton={confirmChange}
			isCalloutVisible={false}
			isCheckBoxTermsContractVisible={false}
			onActionButton={onConfirmChange}
			onValueInput={setPassword}
		/>
	);
});

export default PasswordReset;
